import {axiosNodeClient} from "../http";

export const appointmentAdminServiceNode = {get, today, del, updateStatus}

function get(id, optionSearch) {
    if (id && parseInt(id, 10) > 0) {
        return axiosNodeClient.get('/appointment/' + id);
    }
    else if (optionSearch) {
        return axiosNodeClient.get('/appointment', {
            params: {...optionSearch, action: 'search'}
        });
    }
    else {
        return axiosNodeClient.get('/appointment');
    }
}

function del(id) {
    return axiosNodeClient.delete('/appointment/' + id);
}

function updateStatus (id, status) {
    return axiosNodeClient.put('/appointment/' + id, {
            id: id,
            status: status
        }, {
        params: {
            action: 'updatestatus'
        }
    });
}

function today() {
    return axiosNodeClient.get('/appointment', {
        params: {
            action: 'getToday'
        }
    });
}
